import { render, staticRenderFns } from "./AdminDashboardFundingPot.vue?vue&type=template&id=ea2758b6&"
import script from "./AdminDashboardFundingPot.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardFundingPot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports